import './components.scss';

const PageFooter = (props) => {
    return (
      <div className="pageFooter">
        <div className='pageFooterImage'></div>
        <div className='pageFooterText'><p>© Feb 2025 Odd Nails. All rights reserved.</p></div>
      </div>
    )
  }

  export default PageFooter;